import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import MsiDatagrid from '../../custom/MsiDatagridAuto';

interface DialogPilihBarangProps {
    open: boolean;
    onClose: () => void;
    data: any[]; // array barang
    onSelect: (selectedItem: any) => void;
}

const DialogPilihBarang: React.FC<DialogPilihBarangProps> = ({ open, onClose, data, onSelect }) => {
    // Row click handler
    const handleRowClick = (e: any) => {
        const selectedData = e.data; // data row yang diklik
        if (selectedData) {
            onSelect(selectedData); // panggil parent
            onClose(); // tutup dialog
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ color: '#212121' }}>Pilih Barang</DialogTitle>
            <DialogContent>
                <MsiDatagrid
                    array={data}
                    hiddenColumns={['id']}
                    rowClick={handleRowClick} // pasang handler di sini
                />
            </DialogContent>
        </Dialog>
    );
};

export default DialogPilihBarang;
